export var TagVariantType;
(function (TagVariantType) {
    // NO FEEDBACK
    TagVariantType["PRIMARY"] = "PRIMARY";
    TagVariantType["SECONDARY"] = "SECONDARY";
    TagVariantType["DANGER"] = "DANGER";
    TagVariantType["ON_SURFACE"] = "ON_SURFACE";
    TagVariantType["NEWNESS"] = "NEWNESS";
    TagVariantType["DISABLED_NO_FEEDBACK"] = "DISABLED_NO_FEEDBACK";
    // FEEDBACK
    TagVariantType["INFORMATIVE"] = "INFORMATIVE";
    TagVariantType["SUCCESS"] = "SUCCESS";
    TagVariantType["WARNING"] = "WARNING";
    TagVariantType["ERROR"] = "ERROR";
    TagVariantType["NEUTRAL"] = "NEUTRAL";
    TagVariantType["DISABLED"] = "DISABLED";
})(TagVariantType || (TagVariantType = {}));
//# sourceMappingURL=variants.js.map